import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import { computed, defineComponent, onBeforeUnmount, ref } from "vue";
import { useI18n } from "vue-i18n";
import { ElMessageBox } from "element-plus";
import POSConfigModule from "@/store/modules/pos-config";
import { dialogVisibleForStatus, hideDialog } from "@/utils/vue-helpers/modal";
import NotificationService from "@/services/notification.service";
import { ModalStatus } from "@/constants/modal";
import { LogLevel, LogService } from "@/services/logging";
import { getSalesConfigurationById } from "@/api/gql/sales-configurations";
import { toLocalPOSConfig, loadConfigData } from "@/utils/helpers/pos-config";
import { proceedFetchAndStoreGroupPicture } from "@/utils/helpers/product-category";
import { hasSalesStarted } from "@/utils/vue-helpers/cash-float";
import BookingModule from "@/store/modules/booking";
export default defineComponent({
  name: "ReloadConfiguration",
  setup: function setup() {
    console.log("hi from reloadConfig");

    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var modalVisibility = dialogVisibleForStatus(ModalStatus.ReloadConfiguration);
    var abortController = ref(null); // If the reload completes while the abort confirmation popup is open,
    // dismiss it automatically so it doesn't stay orphaned on screen

    onBeforeUnmount(function () {
      ElMessageBox.close();
    });
    var getLoadingText = computed(function () {
      return POSConfigModule.getLoadingText;
    });
    var progressValue = computed(function () {
      var pcsProgress = POSConfigModule.pcsLoaded;
      var timeslotsProgress = POSConfigModule.timeslotsLoaded;

      if (pcsProgress > 50 || timeslotsProgress) {
        // Cap PCs progress at 50 once timeslots start loading
        pcsProgress = 50;
      }

      if (timeslotsProgress > 35) {
        // Cap timeslots progress at 35
        timeslotsProgress = 35;
      } // extraProgress covers the remaining 5% (seating plans, promotions, offers, locations)


      return 10 + pcsProgress + timeslotsProgress + POSConfigModule.extraProgress;
    });

    function handleBeforeClose(done) {
      LogService.info("User initiated config reload cancellation");
      ElMessageBox.confirm(t("config.abort-reload-warning"), {
        confirmButtonText: t("common.yes"),
        cancelButtonText: t("common.no"),
        type: "warning"
      }).then(function () {
        var _abortController$valu;

        LogService.info("User confirmed to abort config reload");
        (_abortController$valu = abortController.value) === null || _abortController$valu === void 0 ? void 0 : _abortController$valu.abort();
        done();
      }).catch(function () {
        // user cancelled — dialog stays open, reload continues
        LogService.info("User cancelled aborting config reload");
      });
    }

    function resetProgress() {
      POSConfigModule.setPCsLoaded(0);
      POSConfigModule.setTimeslotsLoaded(0);
      POSConfigModule.setExtraProgress(0);
    } // reload the current selected config


    function reloadConfig() {
      return _reloadConfig.apply(this, arguments);
    }

    function _reloadConfig() {
      _reloadConfig = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var controller, signal, throwIfAborted, selectedConfig, refreshedConfig, convertedConfig, success;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                throwIfAborted = function _throwIfAborted() {
                  if (signal.aborted) {
                    throw new DOMException("Aborted", "AbortError");
                  }
                };

                controller = new AbortController();
                abortController.value = controller;
                signal = controller.signal;
                _context2.prev = 4;
                _context2.next = 7;
                return POSConfigModule.fetchGroupInfo();

              case 7:
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](4);
                LogService.info("Error while fetching Group Info", _context2.t0, LogLevel.Error);

              case 12:
                _context2.prev = 12;
                throwIfAborted(); // Pulling group pictures and storing them in Dexie

                _context2.next = 16;
                return proceedFetchAndStoreGroupPicture(signal);

              case 16:
                throwIfAborted(); // refresh the selected config data from backend as well

                selectedConfig = POSConfigModule.selectedConfig;

                if (selectedConfig) {
                  _context2.next = 21;
                  break;
                }

                // If no selected config then we don't reload
                LogService.info("There is no selected config to be reloaded", undefined, LogLevel.Error);
                return _context2.abrupt("return");

              case 21:
                throwIfAborted();
                _context2.next = 24;
                return getSalesConfigurationById(selectedConfig.id);

              case 24:
                refreshedConfig = _context2.sent;
                throwIfAborted();
                convertedConfig = toLocalPOSConfig(refreshedConfig[0]);
                POSConfigModule.SET_SELECTED_CONFIG(_objectSpread({}, convertedConfig)); // clear the selected grid

                POSConfigModule.selectGrid(null);
                _context2.next = 31;
                return loadConfigData(convertedConfig, signal);

              case 31:
                success = _context2.sent;

                if (!signal.aborted) {
                  _context2.next = 37;
                  break;
                }

                LogService.info("Config reload aborted by user");
                resetProgress();

                if (!BookingModule.selectedBooking) {
                  BookingModule.createNewBooking();
                }

                return _context2.abrupt("return");

              case 37:
                if (success) {
                  setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!signal.aborted) {
                              _context.next = 2;
                              break;
                            }

                            return _context.abrupt("return");

                          case 2:
                            // It is sure that every data from remote to start selling is now pulled and stored in local db
                            // lets create a new booking if sales has already started
                            if (hasSalesStarted.value) {
                              console.log("******** calling BookingModule.createNewBooking");
                              BookingModule.createNewBooking();
                            }

                            hideDialog();
                            resetProgress();

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  })), 500);
                }

                _context2.next = 49;
                break;

              case 40:
                _context2.prev = 40;
                _context2.t1 = _context2["catch"](12);

                if (!signal.aborted) {
                  _context2.next = 46;
                  break;
                }

                // User aborted the reload — reset progress and exit silently
                LogService.info("Config reload aborted by user");
                resetProgress();
                return _context2.abrupt("return");

              case 46:
                hideDialog();
                LogService.info("Error while refetching selected config", _context2.t1, LogLevel.Error);
                NotificationService.showGeneralResponseError();

              case 49:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[4, 9], [12, 40]]);
      }));
      return _reloadConfig.apply(this, arguments);
    }

    return {
      t: t,
      modalVisibility: modalVisibility,
      progressValue: progressValue,
      reloadConfig: reloadConfig,
      getLoadingText: getLoadingText,
      handleBeforeClose: handleBeforeClose
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var selectedConfig;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              // refresh the selected config data from backend as well
              selectedConfig = POSConfigModule.selectedConfig;

              if (!selectedConfig) {
                // If no selected config then we don't reload
                LogService.info("There is no selected config to be reloaded", undefined, LogLevel.Error);
                hideDialog();
              } else {
                _this.reloadConfig();
              }

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
});